import StoreSelect from "../components/StoreSelect";
import useModalForm from "../../../@hooks/useModalForm";
export default function useChooseStore() {
  const { open } = useModalForm(StoreSelect);

  const chooseStore = () => {
    return new Promise((resolve,reject)=>{
      open(
        (data) => {
          resolve(data)
        },
        {},
        {
          title: "选择门店",
        }
      );
    })
  };
  return {
    chooseStore,
  };
}